import config from '@/config';
import api from '@/shared/api';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import moment from 'moment';
import { IntraCompanyQueryKey } from './queryKey';
export const useGetIntraCompanyOverviewDetails = (filters, relationCompanyId, userCompanyId) => {
    var _a;
    const intl = useIntl();
    const { data, isLoading, error, fetchNextPage, hasNextPage, isFetchingNextPage, } = useInfiniteQuery([IntraCompanyQueryKey.Details, relationCompanyId, userCompanyId], ({ signal, pageParam }) => api.base
        .get(`${config.appUrls.api}/api/IntraCompany/Details`, {
        params: Object.assign(Object.assign({}, filters), { dateFrom: filters.dateFrom ? moment(filters.dateFrom).toISOString() : null, dateUntil: filters.dateUntil ? moment(filters.dateUntil).toISOString() : null, relationCompanyId,
            userCompanyId, sort: ['RegistrationDate', 'RelationDisplayName', 'RegistrationId'], sortAsc: false, take: 100, page: pageParam !== null && pageParam !== void 0 ? pageParam : 0 }),
        signal,
    })
        .then(res => res.data), {
        enabled: true,
        onError: apiError => {
            handleHttpError(intl)(apiError);
        },
        getNextPageParam: (lastPage, allPages) => lastPage.length === 100 ? allPages.length : undefined,
        notifyOnChangeProps: 'all',
    });
    return {
        data: (_a = data === null || data === void 0 ? void 0 : data.pages) === null || _a === void 0 ? void 0 : _a.flat(1),
        error,
        isLoading,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
    };
};
